import { Injectable } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { BaseWizardService } from '../base.wizard.service';
import {
  ApiService,
  CountryListService,
  DialogService,
  InputDatastoreService,
  ValuesExchangeProvider
} from '@nrwl/common-lib';
import { SyslogConfigWizardStep } from './syslog.configuration.step';
import { BehaviorSubject } from 'rxjs';
import { first } from 'rxjs/operators';

@Injectable()
export class SyslogConfigWizardService extends BaseWizardService {
  openNew: boolean;
  state: ActivatedRoute;
  //eslint-disable-next-line @typescript-eslint/no-explicit-any
  currentParam: any;
  closeWizard: BehaviorSubject<boolean>;

  constructor(
    dataApiService: ApiService,
    state: ActivatedRoute,
    inputDatastoreService: InputDatastoreService,
    countryListService: CountryListService,
    dialogService: DialogService,
    private readonly valuesExchange: ValuesExchangeProvider
  ) {
    super(dataApiService, inputDatastoreService, countryListService, dialogService);
    this.state = state;
    this.stepClass = SyslogConfigWizardStep;
    this.openNew = false;
    this.closeWizard = new BehaviorSubject(false);
  }

  //------------------------------------------------ Wizard control ----------------------------------------------------

  openWizard(
    // eslint-disable-next-line @typescript-eslint/no-explicit-any,@typescript-eslint/explicit-module-boundary-types
    wizardId: any,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any,@typescript-eslint/explicit-module-boundary-types
    wizardConfig: any,
    defaultParamsById = {},
    onSuccess = () => {},
    onFail = () => {}
  ): void {
    super.openWizard(wizardId, wizardConfig, defaultParamsById, onSuccess, onFail);
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any,@typescript-eslint/explicit-module-boundary-types
  _setDefaultParams(step: any, targetOutput: any, defaultParamsById: any = {}): void {
    super._setDefaultParams(step, targetOutput, defaultParamsById);
  }

  setNextStep(): void {
    super.setNextStep();
  }

  _setPreviousStep(): void {
    super._setPreviousStep();
  }

  //eslint-disable-next-line @typescript-eslint/no-explicit-any
  onFinish(): any {
    this.currentStep.onNext();
    this.dirtyFlag = false;
    const output = this._getFormatOutput();
    if (this.editMode) {
      this.method = 'put';
    }

    output.pipeline_id = 1;
    output.rfc = 'rfc5424';
    output.tls_options = {
      caCertificate: '',
      certificate: '',
      privateKey: '',
      privateKeyPassphrase: ''
    };
    const source = this.state.queryParams['_value']?.source;
    if (this.method !== 'post') {
      if (source === 'FA') {
        output.pipeline_id = 0;
        this.dataUrl = '/logging/v1/api/output/';
      }
      this.dataUrl = this.dataUrl + output.identifier;
    } else {
      output.enabled = Array.isArray(output.enabled) ? false : output.enabled;
    }

    const responseProcessed = this._saveRequest(output, false);
    responseProcessed.subscribe(() => {
      this.currentStep = this.finishingStep;
      this.valuesExchange.notifyListeners('syslog_entity', {
        value: 'update',
        cacheBreaker: Date.now()
      });
      if (!this.requestFailed) {
        this.successMessage = !this.editMode
          ? 'Syslog Configuration has been successfully added'
          : 'Syslog Configuration has been successfully updated';
      }
    });
    return responseProcessed;
  }

  showExitInsteadOfClose(): boolean {
    if (this.isFinishingStep() && (this.requestFailed || this.errorMessage)) {
      return true;
    }
    return false;
  }

  //To get data in edit mode
  _getDataForEdit(path: string): void {
    this.apiService
      //eslint-disable-next-line @typescript-eslint/no-explicit-any
      .get$<any>(path, {})
      .pipe(first())
      .subscribe(
        response => {
          this._setOutputForEditMode(response);
          this.defaultParamsById = response;
        },
        error => {
          this._handleErrorResponse(error, this.onFail);
        },
        () => {}
      );
  }
}
